import { useEffect, useRef, useState } from "react";

export default function CursorFollower() {
  const dot = useRef(null);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const el = dot.current;
    if (!el) return;
    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let tx = x;
    let ty = y;

    const move = (e) => {
      x = e.clientX;
      y = e.clientY;
    };
    const enter = (e) => {
      const t = e.target;
      if (t.closest && t.closest("[data-cursor-hover], a, button, [role='button'], input, textarea, select, label")) {
        setHover(true);
      }
    };
    const leave = () => setHover(false);
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", enter);
    window.addEventListener("mouseout", leave);

    let raf;
    const loop = () => {
      tx += (x - tx) * 0.2;
      ty += (y - ty) * 0.2;
      el.style.transform = `translate(${tx}px, ${ty}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", enter);
      window.removeEventListener("mouseout", leave);
      cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={dot} className={`pb-cursor ${hover ? "hover" : ""}`} aria-hidden="true" data-testid="cursor-follower" />;
}
